import React, { useState } from "react";
import { Typography } from "@mui/material";
import { Grid } from "@mui/material";
import { Form, Formik } from "formik";
import InputField from "../../common/InputField";
import { PrimaryButton } from "../../common/Buttons";
import * as Yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../services/user/UserServices";
import { useTranslation } from "react-i18next";
import { getKeyFromText } from "../../utils/Utilities";

const UserFrom = (props) => {
  const { t } = useTranslation();
  const { next, setAuthToken } = props;
  const [clicked, setClicked] = useState(false);

  const navigate = useNavigate();
  const validate = Yup.object({
    Email: Yup.string()
      .matches(
        // eslint-disable-next-line
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        t("Must-be-ValidEmail")
      )
      .required(t("required")),
  });
  const callForgotPassword = async (email) => {
    let response = await forgotPassword(email);
    if (response.success) {
      toast.success(t(getKeyFromText(response.message)));
      setClicked(false);
    } else {
      toast.error(response.message);
      setClicked(false);
    }
  };

  const handleSubmit = async (formik, { resetForm }) => {
    let data = { email: formik?.Email };
    callForgotPassword(data);
    resetForm();
    setClicked(true);
  };
  return (
    <>
      <Toaster />

      <Typography variant="p" fontWeight="bold" color="color.magentaDark1">
        {t("confirm-email")}
      </Typography>
      <Formik
        initialValues={{
          Email: "",
        }}
        enableReinitialize
        validationSchema={validate}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form onChange={() => { }}>
            <InputField
              fullWidth
              variant="standard"
              placeholder="demo@gmail.com"
              label={t("input-3")}
              name="Email"
              type="email"
            />

            <Grid
              container
              spacing={2}
              marginTop="1rem"
              className="form-buttons"
            >
              <Grid item lg={6} width="50%">
                <PrimaryButton
                  title={"send"}
                  width="100%"
                  fullWidth={true}
                  textTransform="capitalize"
                  disabled={clicked}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default UserFrom;
